import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class Schedule extends Component {
  constructor(props) {
    const columns = [
      {Header: 'Meet',
        accessor: 'meet_id',
        'width': 80,
        Cell: props => props.original.team_id === 0 ? '' : <a href={'/results/scheduleGA/meet/'+props.value}>View</a>
      },
      {Header: 'Date', accessor: 'meet_date', 'width': 140},
      {Header: 'Team Score',
        accessor: 'team_score',
        'width': 140,
        Cell: props => props.original.team_id === 0 ? '' : props.value
      },
      {Header: 'Home/Away', accessor: 'home', 'width': 120, Cell: props => props.original.team_id === 0 ? '' : props.value},
      {Header: 'Opponent', accessor: 'opponent', Cell: props => props.original.team_id === 0 ? '' : props.value},
      {Header: 'Desc', accessor: 'meet_desc'},
    ];
    super(props);
    this.state = {
      cols: columns
    };
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  render() {
    if(this.props.meets.length > 0){
      return (
        <div className="scheduleBox">
          <ReactTable
            className="-striped -highlight"
            data={this.props.meets}
            columns={this.state.cols}
            defaultSortMethod={this.defaultSortMethod}
            showPagination={false}
            defaultPageSize={this.props.meets.length}
            pageSize={this.props.meets.length}
          />
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default Schedule;
